import * as z from "zod";
import { mutator } from "./mutator";

const chatComposerControls = [
  "model_picker",
  "effort",
  "plan_mode",
  "voice_mode",
  "chatpad",
  "browse_storage",
  "connector_manage",
  "attachment_remove",
] as const;

export type ChatComposerControl = (typeof chatComposerControls)[number];

export const recordChatComposerControl = mutator({
  schema: z.object({
    control: z.enum(chatComposerControls),
    value: z.string().max(64),
    chatId: z.string().nullish(),
  }),
  resolve: {},
  permissions: {
    none: "records that the caller used a control on their own screen",
  },
  description:
    "Triggered when a user changes a chat setting or opens a chat tool beside the composer.",
  interactionType: "view",
  fn: async () => {},
});
